module.exports = __webpack_public_path__ + "ababd218b56d2b91108658fd76a85890.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/tsutayabooks.png
// module id = 82
// module chunks = 0